export default __webpack_public_path__ + "static/media/tech-1-fig2.d1878bc9.png";